import { hamiVuex } from '@/store/base'
import { projectStore } from '@/store/project'
import { paymentChannelStore } from '@/store/paymentChannel'
import { merchantStore } from '@/store/merchant'
import { priceTableStore } from './priceTable'

function gotoEzboti() {
  if (window.location.hostname === 'revenue.ezfuns.com') {
    let url = String(window.location.href)
    url = url.replace('revenue.ezfuns.com', 'revenue.ezboti.com')
    window.location.replace(url)
    return true
  }
  return false
}

export const homeStore = hamiVuex.store({
  $name: 'home',
  async doLoad() {
    if (gotoEzboti()) {
      return
    }
    if (!merchantStore.isLogin) {
      await merchantStore.doCheckLogin()
    }
    if (!merchantStore.isLogin) {
      window.location.assign(merchantStore.authorizeUrl)
      return
    }
    await projectStore.doLoad()
    await paymentChannelStore.doLoad()
    await priceTableStore.doLoad()
  },
  async switchProject(projectId) {
    if (projectId !== projectStore.currentId) {
      projectStore.setCurrent(projectId)
      window.location.assign('/dash/')
    }
  },
})
